import type { FormField } from '@cli-types/core-engine/schema.js'
import { assertSupportedFormFieldType } from './assert-supported-form-field-type.js'

export function assertSupportedFormFieldTree(field: FormField): void {
  assertSupportedFormFieldType(field)
  if (field.fields) {
    for (const nestedField of field.fields) {
      assertSupportedFormFieldTree(nestedField)
    }
  }
}
